/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you've
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */
/* eslint no-underscore-dangle: 0 */

export enum ChoreoDeployment {
  PROD = 'V2_PROD',
  STAGE = 'V2_STAGE',
  DEV = 'V2_DEV',
  UNKNOWN = 'UNKNOWN',
}

export const apiBaseUrl = window.__RUNTIME_CONFIG__.API_BASE_URL;
export const projectApiBaseUrl = window.__RUNTIME_CONFIG__.PROJECT_API_BASE_URL;
export const declarativeApiBaseUrl =
  window.__RUNTIME_CONFIG__.DECLARATIVE_API_BASE_URL;
export const moesifApiBaseUrl = window.__RUNTIME_CONFIG__.MOESIF_API_BASE_URL;
export const moesifBasicInsightsUrl =
  window.__RUNTIME_CONFIG__.MOESIF_BASIC_INSIGHTS_URL;
export const moesifSettingsPageEnabled =
  window.__RUNTIME_CONFIG__.MOESIF_SETTINGS_PAGE_ENABLED;
export const cioDashboardQueryApiUrl =
  window.__RUNTIME_CONFIG__.CIO_DASHBOARD_QUERY_API_URL;
export const cioConfiguratorApiUrl =
  window.__RUNTIME_CONFIG__.CIO_CONFIGURATOR_API_URL;
export const devOpsApiBaseUrl = window.__RUNTIME_CONFIG__.DEVOPS_API_BASE_URL;
export const platformServicesApiBaseUrl =
  window.__RUNTIME_CONFIG__.PLATFORM_SERVICES_API_BASE_URL;
export const workflowMgtApiUrl = window.__RUNTIME_CONFIG__.WORKFLOW_MGT_API_URL;
export const apiManagerBaseUrl = window.__RUNTIME_CONFIG__.API_MANAGER_BASE_URL;
export const keyServiceURL =
  window.__RUNTIME_CONFIG__.CRYPTO_KEY_SERVICE_BASE_URL;
export const webSubHubUrl = window.__RUNTIME_CONFIG__.WEB_SUB_HUB_URL;
export const apimDcrVersion = window.__RUNTIME_CONFIG__.APIM_DCR_VERSION;
export const apimDcrGratType = window.__RUNTIME_CONFIG__.APIM_DCR_GRANT_TYPE;
export const ballerinaCentralAPI = window.__RUNTIME_CONFIG__
  .API_BALLERINA_CENTRAL_URL as string;
export const aiCopilotUrlSuffix =
  window.__RUNTIME_CONFIG__.AI_COPILOT_URL_SUFFIX;
export const integrationBuilderCopilotBaseUrl =
  window.__RUNTIME_CONFIG__.INTEGRATION_BUILDER_COPILOT_BASE_URL;
export const integrationBuilderLlmModel =
  window.__RUNTIME_CONFIG__.INTEGRATION_BUILDER_LLM_MODEL ||
  'claude-sonnet-4-6';
export const integrationBuilderMaxTokens =
  Number(window.__RUNTIME_CONFIG__.INTEGRATION_BUILDER_MAX_TOKENS) || 1024;
export const integrationBuilderCentralGraphqlUrl =
  window.__RUNTIME_CONFIG__.INTEGRATION_BUILDER_CENTRAL_GRAPHQL_URL;
export const aiCopilotBlogUrl = window.__RUNTIME_CONFIG__.AI_COPILOT_BLOG_URL;
export const aiCopilotDatacollectorBaseUrl =
  window.__RUNTIME_CONFIG__.AI_COPILOT_DATACOLLECTOR_BASE_URL;
export const configMappingSvcUrl =
  window.__RUNTIME_CONFIG__.CONFIG_MAPPING_SERVICE_URL;
export const configSchemaApiUrl =
  window.__RUNTIME_CONFIG__.CONFIG_SCHEMA_API_URL;
export const subscriptionApiUrl =
  window.__RUNTIME_CONFIG__.SUBSCRIPTION_API_URL;
export const orgManagementApiUrl =
  window.__RUNTIME_CONFIG__.ORG_MANAGEMENT_API_URL;
export const orgManagementApiUrlV2 =
  window.__RUNTIME_CONFIG__.ORG_MANAGEMENT_API_URL_V2;
export const auditLoggingApiUrl =
  window.__RUNTIME_CONFIG__.AUDIT_LOGGING_API_URL;
export const auditLoggingApiBaseUrl =
  window.__RUNTIME_CONFIG__.AUDIT_LOGGING_API_BASE_URL;
export const enableSemanticVersionedAuditLoggingApi =
  window.__RUNTIME_CONFIG__.ENABLE_SEMANTIC_VERSIONED_AUDIT_LOGGING_API;
export const componentManagementApiUrl =
  window.__RUNTIME_CONFIG__.COMPONENT_MANAGEMENT_API_URL;
export const componentCreationStatusApiUrl =
  window.__RUNTIME_CONFIG__.COMPONENT_CREATION_STATUS_API_URL;
export const configManagementApiUrl =
  window.__RUNTIME_CONFIG__.CONFIG_MANAGEMENT_API_URL;
export const configGroupManagementApiUrl =
  window.__RUNTIME_CONFIG__.CONFIG_GROUP_MANAGEMENT_API_URL;
export const componentUtilsApiUrl =
  window.__RUNTIME_CONFIG__.COMPONENT_UTILS_API_URL;
export const onpremkeyApiUrl = window.__RUNTIME_CONFIG__.ON_PREM_KEY_API_URL;
export const usersManagementApiUrl =
  window.__RUNTIME_CONFIG__.USERS_MANAGEMENT_API_URL;
export const builtInIdpUserMgtBaseUrl =
  window.__RUNTIME_CONFIG__.BUILT_IN_IDP_USER_MGT_BASE_URL;
export const componentMgtBaseURL =
  window.__RUNTIME_CONFIG__.COMPONENT_MGT_BASE_URL;
export const apimStsBaseURL = window.__RUNTIME_CONFIG__.APIM_STS_BASE_URL;
export const stsMgtSvcBaseUrl = window.__RUNTIME_CONFIG__.STS_MGT_SVC_BASE_URL;
export const configSvcBaseURL = window.__RUNTIME_CONFIG__.CONFIG_SVC_BASE_URL;
export const buildPipelineSvcBaseURL =
  window.__RUNTIME_CONFIG__.BUILD_PIPELINE_SERVICE_API_URL;
export const apiGovernanceBaseUrl =
  window.__RUNTIME_CONFIG__.API_GOVERNANCE_BASE_URL;
export const appdevAuthzBaseUrl =
  window.__RUNTIME_CONFIG__.APPDEV_AUTHZ_BASE_URL;
export const organizationApiUrl =
  window.__RUNTIME_CONFIG__.ORGANIZATION_API_URL;
export const cdnThemeUrl = window.__RUNTIME_CONFIG__.CDN_THEME_URL;
export const publisherEndpointPrefix = window.__RUNTIME_CONFIG__
  .APIM_PUBLISHER_ENDPOINT_PREFIX as string;
export const adminEndpointPrefix = window.__RUNTIME_CONFIG__
  .APIM_ADMIN_ENDPOINT_PREFIX as string;
export const costOptimizationCpBaseUrl =
  window.__RUNTIME_CONFIG__.COST_OPTIMIZATION_CP_URL;

export const billingConsoleUrl = window.__RUNTIME_CONFIG__.BILLING_CONSOLE_URL;

export const enableBillingFeature =
  window.__RUNTIME_CONFIG__.ENABLE_BILLING_FEATURE;

export const enableSTSManagementService =
  window.__RUNTIME_CONFIG__.ENABLE_STS_MANAGEMENT_SERVICE;

export const enableApprovalWorkflowFeature =
  window.__RUNTIME_CONFIG__.ENABLE_APPROVAL_WORKFLOW_FEATURE === 'true';

export const choreoStepBasedEnterpriseTierUuid =
  window.__RUNTIME_CONFIG__.CHOREO_STEP_BASED_ENTERPRISE_TIER_UUID;

export const choreoEnterpriseTierUuid =
  window.__RUNTIME_CONFIG__.CHOREO_ENTERPRISE_TIER_UUID;

export const choreoDeveloperTierUuid =
  window.__RUNTIME_CONFIG__.CHOREO_DEVELOPER_TIER_UUID;

export const choreoTeamTierUuid =
  window.__RUNTIME_CONFIG__.CHOREO_TEAM_TIER_UUID;

export const customDomainAllowedTiers =
  window.__RUNTIME_CONFIG__.CUSTOM_DOMAIN_ALLOWED_TIERS;

export const enableConnectorPublishFeature =
  window.__RUNTIME_CONFIG__.ENABLE_CONNECTOR_PUBLISH_FEATURE;

export const enableEnterpriseLoginOrgsFeature =
  window.__RUNTIME_CONFIG__.ENABLE_ENTERPRISE_LOGIN_ORGS_FEATURE;

export const enableMediationPolicyFeature =
  window.__RUNTIME_CONFIG__.ENABLE_MEDIATION_POLICY_FEATURE;

export const enableConnectorDeleteAndRepublishFeature =
  window.__RUNTIME_CONFIG__.ENABLE_CONNECTOR_DELETE_AND_REPUBLISH_FEATURE;

export const enableDefaultOrgCreation =
  window.__RUNTIME_CONFIG__.ENABLE_DEFAULT_ORG_CREATION;

export const enableResiliencyFeature =
  window.__RUNTIME_CONFIG__.ENABLE_RESILIENCY_FEATURE === 'true';

export const enableCdpResiliencyFeature =
  window.__RUNTIME_CONFIG__.ENABLE_CDP_RESILIENCY_FEATURE === 'true';

export const allowRBAC = window.__RUNTIME_CONFIG__.ALLOW_RBAC;
export const connectorBallerinaVersion =
  window.__RUNTIME_CONFIG__.CONNECTOR_BALLERINA_VERSION;
export const sampleBallerinaVersion =
  window.__RUNTIME_CONFIG__.SAMPLE_BALLERINA_VERSION;

export const emailLoginConfigs = window.__RUNTIME_CONFIG__.EMAIL_LOGIN_CONFIGS;

export const enableMicrosoftLogin =
  window.__RUNTIME_CONFIG__.ENABLE_MICROSOFT_LOGIN;

export const enableGoogleSignup =
  window.__RUNTIME_CONFIG__.ENABLE_GOOGLE_SIGNUP;

export const enableGithubSignup =
  window.__RUNTIME_CONFIG__.ENABLE_GITHUB_SIGNUP;

export const enableMicrosoftSignup =
  window.__RUNTIME_CONFIG__.ENABLE_MICROSOFT_SIGNUP;

export const enableBannerStatus =
  window.__RUNTIME_CONFIG__.ENABLE_BANNER_STATUS === 'true';

export const gaTrackingCode = window.__RUNTIME_CONFIG__
  .GA_TRACKING_CODE as string;

export const hjId = window.__RUNTIME_CONFIG__.HOTJAR_ID;
export const hjSv = window.__RUNTIME_CONFIG__.HOTJAR_VERSION;

export const apiGatewayEndpointSuffix =
  window.__RUNTIME_CONFIG__.API_GATEWAY_ENDPOINT_SUFFIX;

export const apiDevportalUrl = window.__RUNTIME_CONFIG__.API_DEVPORTAL_URL;

export const apiDevOpsportalUrl =
  window.__RUNTIME_CONFIG__.API_DEVOPSPORTAL_URL;

export const apiAppServicelUrl =
  window.__RUNTIME_CONFIG__.CHOREO_APP_SERVICE_BASE_URL;

export const internalMarketplaceUrl =
  window.__RUNTIME_CONFIG__.INTERNAL_MARKETPLACE_API_URL;

export const asgardeoSdkConfig = window.__RUNTIME_CONFIG__.ASGARDEO_SDK_CONFIG;

export const asgardeoSdkResourceUrls =
  window.__RUNTIME_CONFIG__.ASGARDEO_SDK_RESOURCE_SERVER_URLS;

export const asgardeoSdkScopes = window.__RUNTIME_CONFIG__.ASGARDEO_SDK_SCOPES;
export const devportalScopes = window.__RUNTIME_CONFIG__.DEVPORTAL_SCOPES;
export const asgardeoSessionExtensionResource =
  window.__RUNTIME_CONFIG__.ASGARDEO_SESSION_EXTENSION_RESOURCE;

export const asgardeoSessionExtensionInterval =
  window.__RUNTIME_CONFIG__.ASGARDEO_SESSION_EXTENSION_INTERVAL;

export const tokenExchangeConfig =
  window.__RUNTIME_CONFIG__.TOKEN_EXCHANGE_CONFIG;

export const organizationEndpoint =
  window.__RUNTIME_CONFIG__.ORGANIZATION_ENDPOINT;

export const fidpGoogle = window.__RUNTIME_CONFIG__.FIDP_GOOGLE;

export const fidpGitHub = window.__RUNTIME_CONFIG__.FIDP_GITHUB;

export const fidpMicrosoft = window.__RUNTIME_CONFIG__.FIDP_MICROSOFT;

export const fidpAnonymous = window.__RUNTIME_CONFIG__.FIDP_ANONYMOUS;

export const fidpEnterprise = window.__RUNTIME_CONFIG__.FIDP_ENTERPRISE;

export const fidpE2EUser = window.__RUNTIME_CONFIG__.FIDP_E2E;

export const authenticatorGoogle =
  window.__RUNTIME_CONFIG__.AUTHENTICATOR_GOOGLE;

export const authenticatorGithub =
  window.__RUNTIME_CONFIG__.AUTHENTICATOR_GITHUB;

export const authenticatorMicrosoft =
  window.__RUNTIME_CONFIG__.AUTHENTICATOR_MICROSOFT;

export const authenticatorAnonymous =
  window.__RUNTIME_CONFIG__.AUTHENTICATOR_ANONYMOUS;

export const authenticatorEnterprise =
  window.__RUNTIME_CONFIG__.AUTHENTICATOR_ENTERPRISE;

export const gtmId = window.__RUNTIME_CONFIG__.GTM_ID;

export const insightsConfig = window.__RUNTIME_CONFIG__.INSIGHTS_CONFIG;

export const gatewayOrigin = window.__RUNTIME_CONFIG__.GATEWAY_BASE_URL;

export const consoleOrigin = window.__RUNTIME_CONFIG__.CONSOLE_ORIGIN;

export const alertConfigOrigin =
  window.__RUNTIME_CONFIG__.ALERT_CONFIG_BASE_URL;

export const termsOfUse = window.__RUNTIME_CONFIG__.TERMS_OF_USE_LINK;

export const choreoHomePage = window.__RUNTIME_CONFIG__.CHOREO_HOME_PAGE;

export const privacyPolicy = window.__RUNTIME_CONFIG__.PRIVACY_POLICY_LINK;

export const supportCommunity =
  window.__RUNTIME_CONFIG__.SUPPORT_COMMUNITY_LINK;

export const requestDemoLink = window.__RUNTIME_CONFIG__.REQUEST_DEMO_LINK;

export const supportPortal = window.__RUNTIME_CONFIG__.SUPPORT_PORTAL_LINK;

export const choreoSystemOrg = window.__RUNTIME_CONFIG__.CHOREO_SYSTEM_ORG;

export const introVideo = window.__RUNTIME_CONFIG__.INTRO_VIDEO_URL;

export const showUserConsent =
  window.__RUNTIME_CONFIG__.FEATURE_SHOW_USER_EMAIL_CONSENT;

export const showToSConsent =
  window.__RUNTIME_CONFIG__.FEATURE_SHOW_TOS_CONSENT;

export const toSServiceName = window.__RUNTIME_CONFIG__.TOS_SERVICE_NAME;

export const disableAnonymousLogin =
  window.__RUNTIME_CONFIG__.FEATURE_DISABLE_ANONYMOUS_LOGIN_BUTTON;

export const customDomainCnameRecordUS =
  window.__RUNTIME_CONFIG__.CUSTOM_DOMAINS_CNAME_RECORD_US;

export const customDomainCnameRecordEU =
  window.__RUNTIME_CONFIG__.CUSTOM_DOMAINS_CNAME_RECORD_EU;

export const showDevPortalCustomDomain =
  window.__RUNTIME_CONFIG__.FEATURE_SHOW_DEV_PORTAL_CUSTOM_DOMAIN;

export const devPortalCustomDomainCnameRecord =
  window.__RUNTIME_CONFIG__.DEV_PORTAL_CUSTOM_DOMAINS_CNAME_RECORD;

export const enableApiVisibilitySwitch =
  window.__RUNTIME_CONFIG__.FEATURE_ENABLE_API_VISIBILITY_SWITCH;

export const enableDevPortalIdPConfig =
  window.__RUNTIME_CONFIG__.FEATURE_FLAG_DEV_PORTAL_IDP_CONFIG;

export const maxNoOfOrgEnvsAllowed =
  window.__RUNTIME_CONFIG__.MAX_NO_OF_ORG_ENVS_ALLOWED;

export const googleCaptchaSiteKey =
  window.__RUNTIME_CONFIG__.GOOGLE_CAPTCHA_SITE_KEY;

export const disableGoogleCaptcha =
  window.__RUNTIME_CONFIG__.DISABLE_GOOGLE_CAPTCHA;

export const enableGcpSubscriptionFeature =
  window.__RUNTIME_CONFIG__.ENABLE_GCP_SUBSCRIPTION_FEATURE;

export const enableDemoOrgFeature =
  window.__RUNTIME_CONFIG__.ENABLE_DEMO_ORG_FEATURE;

export const demoOrgHandle = window.__RUNTIME_CONFIG__.DEMO_ORG_HANDLE;

export const demoOrgWebAppUrl = window.__RUNTIME_CONFIG__.DEMO_ORG_WEB_APP_URL;

export const demoOrgViewerScopes =
  window.__RUNTIME_CONFIG__.DEMO_ORG_VIEWER_SCOPES;

export const enableAuditLogs = window.__RUNTIME_CONFIG__.ENABLE_AUDIT_LOGS_VIEW;

export const enableUnifiedLogsView =
  window.__RUNTIME_CONFIG__.ENABLE_UNIFIED_LOGS_VIEW;

export const sysApiPrefix = `https://${window.__RUNTIME_CONFIG__.SYS_API_PREFIX}.`;

export const showAutoUndeploymentBanner =
  window.__RUNTIME_CONFIG__.SHOW_AUTO_UNDEPLOYMENT_BANNER;

export const showScaleToZeroEnabledBanner =
  window.__RUNTIME_CONFIG__.SHOW_SCALE_TO_ZERO_BANNER;

export const featureFlagMaintenanceBanner =
  window.__RUNTIME_CONFIG__.FEATURE_FLAG_MAINTENANCE_BANNER;

export const enableAsgardeoMaintenanceFlag =
  window.__RUNTIME_CONFIG__.ENABLE_ASGARDEO_MAINTENANCE_FLAG === 'true';

export const featureFlagMaintenanceCustomMessage =
  window.__RUNTIME_CONFIG__.FEATURE_FLAG_MAINTENANCE_CUSTOM_MESSAGE;

export const featureFlagMaintenanceDateAndTime =
  window.__RUNTIME_CONFIG__.FEATURE_FLAG_MAINTENANCE_DATE_AND_TIME;

export const featureFlagMaintenanceType =
  window.__RUNTIME_CONFIG__.FEATURE_FLAG_MAINTENANCE_TYPE;

export const featureFlagMaintenanceMessageSlackLink =
  window.__RUNTIME_CONFIG__.FEATURE_FLAG_MAINTENANCE_MESSAGE_SLACK_LINK;
// Choreo APIS Config
// TODO Support multiple environments as a future improvement, until then URLs will be hardcoded
// export const choreoApisConfigCnameRecord =
//   window.__RUNTIME_CONFIG__.APIS_CONFIG_CNAME_RECORD;
export const choreoApisConfigCnameRecord =
  'customdns.e1-us-east-azure.preview-dv.choreoapis.dev';

// export const orgDefaultDomainSuffix =
//   window.__RUNTIME_CONFIG__.ORG_DEFAULT_DOMAIN_SUFFIX;
export const orgDefaultDomainSuffix =
  '-prod.e1-us-east-azure.preview-dv.choreoapis.dev';

export const fidpEmail = 'LOCAL';

const rawAzureInsightsKey = window.__RUNTIME_CONFIG__.AZURE_INSIGHTS_KEY;
export const azureInsightsKey =
  rawAzureInsightsKey === 'disabled' ? '' : rawAzureInsightsKey;

export const moesifAppKey = window.__RUNTIME_CONFIG__.MOESIF_APP_API_KEY;

/**
 * Orgs allowed to see the embedded Moesif Logs/Traces dashboards (component
 * and project Logs pages, and the Traces tab). Comma-separated org UUIDs, or
 * '*' to enable for every org.
 */
export function isMoesifLogsAndTracesEnabled(orgUUID: string): boolean {
  const orgs = window.__RUNTIME_CONFIG__.MOESIF_LOGS_AND_TRACES_ENABLED_ORGS;
  if (!orgs) {
    return false;
  }
  const orgList = orgs.split(',');
  return orgList.includes('*') || orgList.includes(orgUUID);
}

export const trackingExcludedOrgs: string[] =
  window.__RUNTIME_CONFIG__.TRACKING_EXCLUDED_ORGS ?? [];

// Choreo running environment(dev,stage,prod) is defined by the variable 'choreoEnvironment'
const getChoreoEnvironment = () => {
  const sentryEnv = window.__RUNTIME_CONFIG__.SENTRY_ENV;
  if (sentryEnv === 'V2_DEV') {
    return ChoreoDeployment.DEV;
  }
  if (sentryEnv === 'V2_PROD') {
    return ChoreoDeployment.PROD;
  }
  if (sentryEnv === 'V2_STAGE') {
    return ChoreoDeployment.STAGE;
  }
  return ChoreoDeployment.UNKNOWN;
};

export const choreoEnvironment = getChoreoEnvironment();
export const isDevEnvironment = choreoEnvironment === ChoreoDeployment.DEV;
export const isProdEnvironment = choreoEnvironment === ChoreoDeployment.PROD;
export const isStageEnvironment = choreoEnvironment === ChoreoDeployment.STAGE;
export const githubAppConfigs = window.__RUNTIME_CONFIG__.GH_APP_CONFIGS;
export const hiddenSampleList = window.__RUNTIME_CONFIG__.HIDDEN_SAMPLE_LIST;
export const githubURL = window.__RUNTIME_CONFIG__.GIT_HUB_URL;
export const ballerinaLowCodeResourcesVersion =
  window.__RUNTIME_CONFIG__.BALLERINA_LOW_CODE_RESOURCES_VERSION;
export const choreoSamplesVersion =
  window.__RUNTIME_CONFIG__.CHOREO_SAMPLES_VERSION;
export const scaleToZeroDockLink = window.__RUNTIME_CONFIG__.SCALE_TO_ZERO_DOC;
export const buildTimeEnvVarsDocLink =
  window.__RUNTIME_CONFIG__.BUILD_TIME_ENVIRONMENT_VARIABLES_DOC_LINK;
export const customizableCIDocLink =
  window.__RUNTIME_CONFIG__.CUSTOMIZABLE_CI_DOC_LINK;
export const notificationBannerInterval =
  window.__RUNTIME_CONFIG__.NOTIFICATION_BANNER_INTERVAL;
// Add fidp for code-server creation
export const featureFlagCodeEditorSso =
  window.__RUNTIME_CONFIG__.FEATURE_FLAG_CODE_EDITOR_SSO;

export const githubBaseUrl = 'https://github.com/';
export const bitbucketBaseUrl = 'https://bitbucket.org/';
export const gitLabBaseUrl = 'https://gitlab.com/';
export const azureDevOpsBaseUrl = 'https://dev.azure.com/';

export const enableProfileSelector =
  window.__RUNTIME_CONFIG__.ENABLE_PROFILE_SELECTOR;
export const disableEnterpriseLogin =
  window.__RUNTIME_CONFIG__.DISABLE_ENTERPRISE_LOGIN;

export const enableCloudEditorDeploymentDelays =
  window.__RUNTIME_CONFIG__.ENABLE_CLOUD_EDITOR_DEPLOYMENT_DELAYS === 'true';
export const cloudEditorRedirectDelay =
  window.__RUNTIME_CONFIG__.CLOUD_EDITOR_REDIRECT_DELAY || 5000;

export const enableWso2BiPrebuilds =
  window.__RUNTIME_CONFIG__.ENABLE_WSO2_BI_PREBUILDS === 'true';
export const wso2BiPrereleaseTag =
  window.__RUNTIME_CONFIG__.WSO2_BI_PRERELEASE_TAG || 'nightly';

export const featureFlagComponentInsights =
  window.__RUNTIME_CONFIG__.FEATURE_FLAG_COMPONENT_INSIGHTS;

export const enableInternalAPIFeature =
  window.__RUNTIME_CONFIG__.ENABLE_INTERNAL_API_FEATURE;

export const enablePlatformServicesFeature =
  window.__RUNTIME_CONFIG__.ENABLE_PLATFORM_SERVICES_FEATURE === 'true';

export const enableGenAIServicesFeature =
  window.__RUNTIME_CONFIG__.ENABLE_GEN_AI_SERVICES === 'true';

export const openAITemplateId = window.__RUNTIME_CONFIG__.OPEN_AI_TEMPLATE_ID;

export const mistralAITemplateId =
  window.__RUNTIME_CONFIG__.MISTRAL_AI_TEMPLATE_ID;

export const antropicAITemplateId =
  window.__RUNTIME_CONFIG__.ANTROPIC_AI_TEMPLATE_ID;

export const azureOpenAiTemplateId =
  window.__RUNTIME_CONFIG__.AZURE_OPEN_AI_TEMPLATE_ID;

export function platformServicesEnabledForOrg(orgId: string): boolean {
  const enabledOrgs =
    window.__RUNTIME_CONFIG__.PLATFORM_SERVICES_ENABLED_ORGANIZATIONS;
  if (!enabledOrgs) {
    return false;
  }
  if (enabledOrgs === '*') {
    return true;
  }
  return enabledOrgs.toLowerCase().includes(orgId.toLowerCase());
}

export const enableRedisServiceCreation =
  window.__RUNTIME_CONFIG__.ENABLE_REDIS_SERVICE_CREATION === 'true';

export const enableConfigAzureSubscriptionFeature =
  window.__RUNTIME_CONFIG__.ENABLE_CONFIGURE_AZURE_SUBSCRIPTION_FEATURE;

export const choreoSaasOfferUrl =
  window.__RUNTIME_CONFIG__.CHOREO_SAAS_OFFER_URL;

export const enableGraphQLFeature =
  window.__RUNTIME_CONFIG__.ENABLE_GRAPHQL_FEATURE;

export const userEnabledFeaturePreviewList =
  window.__RUNTIME_CONFIG__.USER_ENABLED_FEATURE_PREVIEW_LIST;

export const FREE_COMPONENT_LIMIT = 5;
export const FREE_DEPLOYMENT_TRACK_LIMIT = 2;

export const prebuiltIntegrationsUrl =
  window.__RUNTIME_CONFIG__.PREBUILT_INTEGRATIONS_URL;

export const samplesUrl = window.__RUNTIME_CONFIG__.SAMPLES_URL;

export const availableProjectRegions = (
  window.__RUNTIME_CONFIG__.PROJECT_DP_REGIONS || ''
).split(',');

export const regionSelectionEnabled = availableProjectRegions.length > 1;
export const enableAutoDeployByDefault =
  window.__RUNTIME_CONFIG__.ENABLE_AUTO_DEPLOY_BY_DEFAULT;

export const enableConfigInitOnCompCreation =
  window.__RUNTIME_CONFIG__.ENABLE_CONFIG_INIT_ON_COMP_CREATION;

export const enableIPaaSFeature =
  window.__RUNTIME_CONFIG__.ENABLE_IPAAS_FEATURE;

export const asgardeoKeyManagerBaseUrl =
  window.__RUNTIME_CONFIG__.ASGARDEO_KEY_MANAGER_BASE_URL;
export const enableAsgardeoKeyManagerSwitch =
  window.__RUNTIME_CONFIG__.ENABLE_ASGARDEO_KEY_MANAGER_SWITCH;

export const enableExternalCIFeature =
  window.__RUNTIME_CONFIG__.ENABLE_EXTERNAL_CI_FEATURE === 'true';
export const enableHelmMarketplace =
  window.__RUNTIME_CONFIG__.ENABLE_HELM_MARKETPLACE === 'true';
// RBAC Permissions
export const roleMappingManage = window.__RUNTIME_CONFIG__.ROLE_MAPPING_MANAGE;
export const roleMappingView = window.__RUNTIME_CONFIG__.ROLE_MAPPING_VIEW;
export const roleMappingCreate = window.__RUNTIME_CONFIG__.ROLE_MAPPING_CREATE;
export const roleMappingUpdate = window.__RUNTIME_CONFIG__.ROLE_MAPPING_UPDATE;
export const roleMappingDelete = window.__RUNTIME_CONFIG__.ROLE_MAPPING_DELETE;
export const roleView = window.__RUNTIME_CONFIG__.ROLE_VIEW;
export const roleCreate = window.__RUNTIME_CONFIG__.ROLE_CREATE;
export const roleUpdate = window.__RUNTIME_CONFIG__.ROLE_UPDATE;
export const roleDelete = window.__RUNTIME_CONFIG__.ROLE_DELETE;
export const roleManage = window.__RUNTIME_CONFIG__.ROLE_MANAGE;
export const userManage = window.__RUNTIME_CONFIG__.USER_MANAGE;
export const userView = window.__RUNTIME_CONFIG__.USER_VIEW;
export const userDelete = window.__RUNTIME_CONFIG__.USER_DELETE;
export const userUpdate = window.__RUNTIME_CONFIG__.USER_UPDATE;
export const permissionView = window.__RUNTIME_CONFIG__.PERMISSION_VIEW;
export const invitationManage = window.__RUNTIME_CONFIG__.INVITATION_MANAGE;
export const invitationSend = window.__RUNTIME_CONFIG__.INVITATION_SEND;
export const invitationDelete = window.__RUNTIME_CONFIG__.INVITATION_DELETE;
export const invitationView = window.__RUNTIME_CONFIG__.INVITATION_VIEW;
export const componentTrigger = window.__RUNTIME_CONFIG__.COMPONENT_TRIGGER;
export const componentCreate = window.__RUNTIME_CONFIG__.COMPONENT_CREATE;
export const componentConfigView =
  window.__RUNTIME_CONFIG__.COMPONENT_CONFIG_VIEW;
export const componentLogsView = window.__RUNTIME_CONFIG__.COMPONENT_LOGS_VIEW;
export const componentInitView = window.__RUNTIME_CONFIG__.COMPONENT_INIT_VIEW;
export const componentFileView = window.__RUNTIME_CONFIG__.COMPONENT_FILE_VIEW;
export const componentManage = window.__RUNTIME_CONFIG__.COMPONENT_MANAGE;
export const globalConfigView = window.__RUNTIME_CONFIG__.GLOBAL_CONFIG_VIEW;
export const globalConfigUpdate =
  window.__RUNTIME_CONFIG__.GLOBAL_CONFIG_UPDATE;
export const globalConfigDelete =
  window.__RUNTIME_CONFIG__.GLOBAL_CONFIG_DELETE;
export const globalConfigCreate =
  window.__RUNTIME_CONFIG__.GLOBAL_CONFIG_CREATE;
export const globalConfigManage =
  window.__RUNTIME_CONFIG__.GLOBAL_CONFIG_MANAGE;
export const configView = window.__RUNTIME_CONFIG__.CONFIG_VIEW;
export const configDelete = window.__RUNTIME_CONFIG__.CONFIG_DELETE;
export const configCreate = window.__RUNTIME_CONFIG__.CONFIG_CREATE;
export const configManage = window.__RUNTIME_CONFIG__.CONFIG_MANAGE;
export const themeView = window.__RUNTIME_CONFIG__.THEME_VIEW;
export const themeDelete = window.__RUNTIME_CONFIG__.THEME_DELETE;
export const themeCreate = window.__RUNTIME_CONFIG__.THEME_CREATE;
export const themeManage = window.__RUNTIME_CONFIG__.THEME_MANAGE;
export const themeDeploy = window.__RUNTIME_CONFIG__.THEME_DEPLOY;
export const enterpriseLoginConfigView =
  window.__RUNTIME_CONFIG__.ENTERPRISE_LOGIN_CONFIG_VIEW;
export const enterpriseLoginManage =
  window.__RUNTIME_CONFIG__.ENTERPRISE_LOGIN_MANAGE;
export const selfSignupConfigView =
  window.__RUNTIME_CONFIG__.SELF_SIGNUP_CONFIG_VIEW;
export const selfSignupConfigUpdate =
  window.__RUNTIME_CONFIG__.SELF_SIGNUP_CONFIG_UPDATE;
export const selfSignupApprovalView =
  window.__RUNTIME_CONFIG__.SELF_SIGNUP_APPROVAL_VIEW;
export const selfSignupApprovalUpdate =
  window.__RUNTIME_CONFIG__.SELF_SIGNUP_APPROVAL_UPDATE;
export const selfSignupManage = window.__RUNTIME_CONFIG__.SELF_SIGNUP_MANAGE;
export const auditLogsManage = window.__RUNTIME_CONFIG__.AUDIT_LOGS_MANAGE;
export const auditLogsView = window.__RUNTIME_CONFIG__.AUDIT_LOGS_VIEW;
export const onPremKeyView = window.__RUNTIME_CONFIG__.ON_PREM_KEY_VIEW;
export const onPremKeyUpdate = window.__RUNTIME_CONFIG__.ON_PREM_KEY_UPDATE;
export const onPremKeyDelete = window.__RUNTIME_CONFIG__.ON_PREM_KEY_DELETE;
export const onPremKeyCreate = window.__RUNTIME_CONFIG__.ON_PREM_KEY_CREATE;
export const onPremKeyManage = window.__RUNTIME_CONFIG__.ON_PREM_KEY_MANAGE;
export const choreoUserMgtStoreView =
  window.__RUNTIME_CONFIG__.CHOREO_USER_MGT_VIEW_STORE_PERMISSION;
export const choreoOrgManage = window.__RUNTIME_CONFIG__.CHOREO_ORG_MANAGE;

export const enableYAMLCustomizationFeature =
  window.__RUNTIME_CONFIG__.ENABLE_YAML_CUSTOMIZATION_FEATURE === 'true';
export const enableDeploymentTrackListing =
  window.__RUNTIME_CONFIG__.ENABLE_DEPLOYMENT_TRACK_LISTING === 'true';
export const enableComponentNameFlowConsole =
  window.__RUNTIME_CONFIG__.ENABLE_COMPONENT_NAME_FLOW_CONSOLE === 'true';
export const enableDTDelete =
  window.__RUNTIME_CONFIG__.ENABLE_DT_DELETE_CONSOLE === 'true';
export const enableConfigGroupManagement =
  window.__RUNTIME_CONFIG__.ENABLE_CONFIG_GROUP_MANAGEMENT === 'true';
export const YAMLCustomizationEnabledTypes =
  window.__RUNTIME_CONFIG__.YAML_CUSTOMIZATION_ENABLED_TYPES;
export const ipifyServiceUrl = window.__RUNTIME_CONFIG__.IPIFY_SERVICE_URL;
export const enableAddingSFLeadFeature =
  window.__RUNTIME_CONFIG__.ENABLE_ADDING_SF_LEAD;
export const pdpDomainCustomizedOrgs =
  window.__RUNTIME_CONFIG__.PDP_DOMAIN_CUSTOMIZED_ORGS;

export const customDomainWhitelistedOrgs =
  window.__RUNTIME_CONFIG__.CUSTOM_DOMAIN_WHITELISTED_ORGS;

export const enableWebAppShortUrlFeature =
  window.__RUNTIME_CONFIG__.ENABLE_WEBAPP_SHORT_URL_CONFIG === 'true';

export const webAppShortUrlDomains = {
  US: getValidDomainOrEmptyString(
    window.__RUNTIME_CONFIG__.ENV_WEBAPP_SHORT_URL_DOMAINS.US
  ),
  EU: getValidDomainOrEmptyString(
    window.__RUNTIME_CONFIG__.ENV_WEBAPP_SHORT_URL_DOMAINS.EU
  ),
} as { [key: string]: string };

export const enableCustomCI =
  window.__RUNTIME_CONFIG__.ENABLE_CUSTOM_CI === 'true';

function getValidDomainOrEmptyString(domain: string): string {
  if (domain && !domain.startsWith('$')) {
    return domain;
  }
  return '';
}
export const bitbucketServerCustomerOrgUuid =
  window.__RUNTIME_CONFIG__.BITBUCKET_SERVER_CUSTOMER_ORGS.split('|');

export const choreoURLManagerUrl =
  window.__RUNTIME_CONFIG__.CHOREO_URL_MANAGER_URL;
export const enableTaskExecutionsFeature =
  window.__RUNTIME_CONFIG__.ENABLE_TASK_EXECUTIONS_FEATURE === 'true';

export const dependencyConfigURL =
  window.__RUNTIME_CONFIG__.DEPENDENCY_CONFIG_URL;

export const devportalConfigURL = window.__RUNTIME_CONFIG__.DEVPORTAL_URL;

export const devportalV2ConfigURL = window.__RUNTIME_CONFIG__.DEVPORTAL_V2_URL;

export const enableUpdateButton =
  window.__RUNTIME_CONFIG__.ENABLE_UPDATE_BUTTON;

export const choreoManagedAuthDocUrl =
  window.__RUNTIME_CONFIG__.CHOREO_MANAGED_AUTH_DOC_URL;

export const choreoApprovalWorkflowsDocUrl =
  window.__RUNTIME_CONFIG__.CHOREO_APPROVAL_WORKFLOWS_DOC_URL;

export const createCredentialsDocUrl =
  window.__RUNTIME_CONFIG__.CREATE_CREDENTIALS_DOC_URL;
export const projectLevelConnectionCreatingEnableDate =
  window.__RUNTIME_CONFIG__.ENABLE_PROJECT_CONNECTION_CREATION_DATE;

export const enableComponentNotification =
  window.__RUNTIME_CONFIG__.ENABLE_COMPONENT_NOTIFICATION === 'true';
export const componentNotificationText =
  window.__RUNTIME_CONFIG__.COMPONENT_NOTIFICATION_TEXT;
export const componentNotificationLinkText =
  window.__RUNTIME_CONFIG__.COMPONENT_NOTIFICATION_LINK_TEXT;
export const componentNotificationLink =
  window.__RUNTIME_CONFIG__.COMPONENT_NOTIFICATION_LINK;
export const enableURLSettingTab =
  window.__RUNTIME_CONFIG__.ENABLE_CUSTOM_URL_MAPPINGS_FEATURE;
export const enableRunTasksWithParameters =
  window.__RUNTIME_CONFIG__.RUN_TASKS_WITH_PARAMETERS === 'true';
export const integrationAsApiQSGDocLink =
  window.__RUNTIME_CONFIG__.INTEGRATION_AS_API_QSG_DOC_LINK;
export const automationQSGDocLink =
  window.__RUNTIME_CONFIG__.AUTOMATION_QSG_DOC_LINK;
export const enableChoreoAuthorizationDate =
  window.__RUNTIME_CONFIG__.ENABLE_CHOREO_AUTHORIZATION_DATE;
export const choreoConsoleTestHeader =
  window.__RUNTIME_CONFIG__.CHOREO_CONSOLE_TEST_HEADER;
export const enableApiKeyFeature =
  window.__RUNTIME_CONFIG__.ENABLE_API_KEY_FEATURE === 'true';
export const enableExternalConsumerComponent =
  window.__RUNTIME_CONFIG__.ENABLE_EXTERNAL_CONSUMER_COMPONENT === 'true';
export const choreoManagedAuthLocalDevDocUrl =
  window.__RUNTIME_CONFIG__.CHOREO_MANAGED_AUTH_LOCAL_DEV_DOC_URL;
export const choreoResourceAuthzDocUrl =
  window.__RUNTIME_CONFIG__.CHOREO_RESOURCE_AUTHZ_DOC_URL;
export const choreoMigrateSourceConfigDoc =
  window.__RUNTIME_CONFIG__.CHOREO_MIGRATE_SOURCE_CONFIG_DOC_URL;
export const choreoManagedAuthLocalDevProxyPackage =
  window.__RUNTIME_CONFIG__.CHOREO_MANAGED_AUTH_LOCAL_DEV_PROXY_PACKAGE;
export const queuedStatusPollingInterval =
  window.__RUNTIME_CONFIG__.QUEUED_STATUS_POLLING_INTERVAL;
export const inProgressStatusPollingInterval =
  window.__RUNTIME_CONFIG__.IN_PROGRESS_STATUS_POLLING_INTERVAL;

export const downloadLogsPageSize =
  parseInt(window.__RUNTIME_CONFIG__.DOWNLOAD_LOGS_PAGE_SIZE, 10) || 5000;

export const enableMarketplaceIntRoutingFeature =
  window.__RUNTIME_CONFIG__.ENABLE_MARKETPLACE_INT_ROUTING_FEATURE === 'true';

export function isCustomSubPoliciesEnabled(userOrgId: string): boolean {
  const orgEnvString =
    window.__RUNTIME_CONFIG__.CUSTOM_SUBSCRIPTION_POLICY_HANDLING_ORG;
  if (orgEnvString === undefined) {
    return false;
  }
  const orgList = orgEnvString.split(',');
  return orgList.includes(userOrgId) || orgList.includes('*');
}

export function isSubscriptionApprovalEnabled(userOrgId: string): boolean {
  const orgEnvString = window.__RUNTIME_CONFIG__.SUBSCRIPTION_APPROVAL_ORGS;
  if (orgEnvString === undefined) {
    return false;
  }
  const orgList = orgEnvString.split(',');
  return orgList.includes(userOrgId) || orgList.includes('*');
}

export const enableDefaultEndpointUrlFeature =
  window.__RUNTIME_CONFIG__.ENABLE_DEFAULT_ENDPOINT_URL_FEATURE === 'true';

export const enableRunWithArgsForBallerina =
  window.__RUNTIME_CONFIG__.ENABLE_RUN_WITH_ARGS_FOR_BALLERINA === 'true';

export const enableEnvironmentDeletion =
  window.__RUNTIME_CONFIG__.ENABLE_ENVIRONMENT_DELETION_FEATURE === 'true';

export const enableQuickDeploySamplesFeature =
  window.__RUNTIME_CONFIG__.ENABLE_QUICK_DEPLOY_SAMPLES_FEATURE === 'true';

export const connectionsEnabledComponents = (
  window.__RUNTIME_CONFIG__.CONNECTIONS_ENABLED_COMPONENT_TYPES || ''
).split('|');

export function isExecutePageObsAPIEnabled(userOrgId: string): boolean {
  const orgEnvString =
    window.__RUNTIME_CONFIG__.EXECUTE_PAGE_OBS_API_ENABLED_ORGS;
  if (!orgEnvString) {
    return false;
  }
  const orgList = orgEnvString.split(',');
  if (orgList.length === 0) {
    return false;
  }
  return orgList.includes(userOrgId) || orgList.includes('*');
}

export function isStopExecutionEnabled(userOrgId: string): boolean {
  const orgEnvString = window.__RUNTIME_CONFIG__.STOP_EXECUTION_ENABLED_ORGS;
  if (!orgEnvString) {
    return false;
  }
  const orgList = orgEnvString.split(',');
  if (orgList.length === 0) {
    return false;
  }
  return orgList.includes(userOrgId) || orgList.includes('*');
}

export const apiKeyServiceUrl = window.__RUNTIME_CONFIG__.API_KEY_SERVICE_URL;

export const allowPublishingAPIKeyEnabledAPIs =
  window.__RUNTIME_CONFIG__.ALLOW_PUBLISHING_API_KEY_ENABLED_APIS === 'true';

export const setApiKeyAsDefaultSecurityScheme =
  window.__RUNTIME_CONFIG__.SET_API_KEY_AS_DEFAULT_SECURITY_SCHEME === 'true';

export function isProxyFromGHEnabled(orgUUID: string): boolean {
  const orgs = window.__RUNTIME_CONFIG__.GH_PROXY_ENABLED_ORGS;
  if (orgs) {
    return orgs.split(',').includes(orgUUID);
  }
  return false;
}
export const enableAPIMResourceAuthChecks =
  window.__RUNTIME_CONFIG__.ENABLE_APIM_RESOURCE_AUTH_CHECKS === 'true';

export function isAPIKeySupportedPDPOrganization(orgId: string): boolean {
  const orgs = window.__RUNTIME_CONFIG__.API_KEY_SUPPORTED_PDP_ORGS;
  if (orgs) {
    return orgs.split(',').includes(orgId);
  }
  return false;
}

export function isCustomizableCIEnabled(orgUUID: string): boolean {
  const orgs = window.__RUNTIME_CONFIG__.CUSTOMIZABLE_CI_ENABLED_ORGS;
  if (orgs) {
    return orgs.split(',').includes(orgUUID);
  }
  return false;
}

export const isMultiVisibilitySupportEnabled =
  window.__RUNTIME_CONFIG__.ENABLE_MULTI_VISIBILITY_SUPPORT === 'true';

export const previewFeatureEnabledList =
  window.__RUNTIME_CONFIG__.PREVIEW_FEATURE_ENABLE_LIST;

/**
 * The `AI Copilot` feature preview cannot be used here: it is
 * scoped to an organization, which is unknown until the user has signed in.
 */
export const enableLoginCopilotPrompt =
  window.__RUNTIME_CONFIG__.ENABLE_LOGIN_COPILOT_PROMPT === 'true';

export const ragIngestionBackendUrl =
  window.__RUNTIME_CONFIG__.RAG_INGESTION_BACKEND;

export function isPdpCreationAllowedOrg(orgId: string): boolean {
  const orgs =
    window.__RUNTIME_CONFIG__.PDP_CREATION_ENABLED_ORGS.toLowerCase();
  if (orgs.includes('*')) {
    return true; // limited to all internal users due to feature preview
  }
  return orgs.toLowerCase().split(',').includes(orgId.toLowerCase());
}

export const pdpCreationEnabledClouds =
  window.__RUNTIME_CONFIG__.PDP_CREATION_ENABLED_CLOUDS;

export const enableNonBuildpackBuildConfigs =
  window.__RUNTIME_CONFIG__.ENABLE_NON_BUILDPACK_BUILD_CONFIGS === 'true';

export const enablePullLatestSubmodulesFeature =
  window.__RUNTIME_CONFIG__.ENABLE_PULL_LATEST_SUBMODULES === 'true';

export const enableUserProvidedEndpoint =
  window.__RUNTIME_CONFIG__.ENABLE_USER_PROVIDED_ENDPOINT === 'true';

export const enableUrlCustomizationWorkflow =
  window.__RUNTIME_CONFIG__.ENABLE_URL_CUSTOMIZATION_WORKFLOW === 'true';

export const enableAPISettingsUX =
  window.__RUNTIME_CONFIG__.ENABLE_API_SETTINGS_UX === 'true';

export const projectNameDenyList =
  window.__RUNTIME_CONFIG__.PROJECT_NAME_DENY_LIST.split(',');

export const enableMCPServerSupport =
  window.__RUNTIME_CONFIG__.ENABLE_MCP_SERVER_SUPPORT === 'true';

export const enableDataPlaneInsights =
  window.__RUNTIME_CONFIG__.ENABLE_DATA_PLANE_INSIGHTS === 'true';

export const enableAutomationPipelines =
  window.__RUNTIME_CONFIG__.ENABLE_AUTOMATION_PIPELINES_FEATURE === 'true';

export function isCentralizedCertManagementEnabled(orgUUID: string): boolean {
  const orgs =
    window.__RUNTIME_CONFIG__.REACT_APP_CENTRALIZED_CERT_MANAGER_ENABLED_ORGS;
  if (orgs) {
    if (orgs.trim() === '*') {
      return true;
    }
    return orgs.split(',').includes(orgUUID);
  }
  return false;
}

export const availableLoginRegions =
  window.__RUNTIME_CONFIG__.AVAILABLE_LOGIN_REGIONS.split(',');

export function isMiConfigMigrationEnabled(userOrgId: string): boolean {
  const orgEnvString =
    window.__RUNTIME_CONFIG__.MI_CONFIG_MIGRATION_ENABLED_ORGS;
  if (!orgEnvString) {
    return false;
  }
  const orgList = orgEnvString.split(',').filter((org) => org.trim() !== '');
  if (orgList.length === 0) {
    return false;
  }
  return orgList.includes(userOrgId) || orgList.includes('*');
}

export function isSubOrgEnabledOrg(orgUuid: string): boolean {
  const enabledOrgs =
    window.__RUNTIME_CONFIG__.FEATURE_FLAG_SUB_ORGS_ENABLED_ORGS;
  if (!enabledOrgs) {
    return false;
  }
  if (enabledOrgs === '*') {
    return true;
  }
  return enabledOrgs
    .split(',')
    .map((uuid) => uuid.trim().toLowerCase())
    .includes(orgUuid.toLowerCase());
}

export const newIdevpPermissionModelEnabled =
  window.__RUNTIME_CONFIG__.ENABLE_NEW_HASPERMISSIONV2_IDEVP === 'true';

export const envWiseAccessControlFeatureFlagEnabled =
  window.__RUNTIME_CONFIG__.ENABLE_ENV_WISE_ACCESS_CONTROL === 'true';

export const isFeatureDisabled = (featureName: string): boolean =>
  Array.isArray(window.__RUNTIME_CONFIG__.DISABLED_FEATURES) &&
  window.__RUNTIME_CONFIG__.DISABLED_FEATURES.includes(featureName);

export const assetCdnUrl = window.__RUNTIME_CONFIG__.ASSET_CDN_URL;

export const userPortalConfigURL = window.__RUNTIME_CONFIG__.USER_PORTAL_URL;
